import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &:hover {
    color: ${color.SCOOTER};
  }
`

export const SubLabel = styled.div`
  line-height: 1.25rem;
  font-size: 0.875rem;
`

export const LabelColumn = styled.div`
  flex-grow: 1;
  color: ${color.MORTAR};
  font-size: 1.125rem;
`

export const SwitchColumn = styled.div`
  flex-grow: 0;
`

export const Label = styled.div``
